<div class="box-api">
    <iframe src="https://api-dev.legitid.org/dashboard/swagger/index.html"></iframe>
</div>